:host {
    display: block;
}

.action-bar-container {
    width: auto; 
    height: 48px;
    display: flex;
    flex-direction: row;
    gap: 0.4rem;
    align-items: center;
}